const screenInputData = {
  DeleteMusteri: [{"name":"DeleteMusteri","type":"String","cardinality":1,"isExpandedPanel":null}],
	DeleteDepartman: [{"name":"DeleteDepartman","type":"String","cardinality":1,"isExpandedPanel":null}],
	DeleteTicket: [{"name":"ScreenDelete","type":"String","cardinality":1,"isExpandedPanel":null}],
	KullaniciBilgisi: [{"name":"KullaniciBilgi","type":"String","cardinality":1,"isExpandedPanel":null}],
	DeleteKullanici: [{"name":"DeleteKullanici","type":"String","cardinality":1,"isExpandedPanel":null}],
	TicketDetay: [{"name":"TicketID","type":"Int32","cardinality":1,"isExpandedPanel":null}],
	TicketDuzenle: [{"name":"TicketID","type":"Int32","cardinality":1,"isExpandedPanel":null}]
};

export class ScreenInputHelper {
  public static getScreenInputValue(screenName: string, inputName: string, value: string): any {
    switch (this.getScreenInputType(screenName, inputName)) {
      case "String":
        return value;
      case "Boolean":
        return value.toLowerCase() === "true";
      // TODO
    }

    return value;
  }

  private static getScreenInputType(screenName: string, inputName: string): string {
    const data = screenInputData[screenName]?.find((x) => x.Name === inputName);
    return data?.TypeName ? data.TypeName : "";
  }
}
